import useIsMobile from "hooks/useIsMobile.ts";
import React, { forwardRef, useMemo } from "react";
import RotaItem from "./components/DropdownRotaItem.tsx";
import DropdownSection from "./components/DropdownSection.tsx";
import {
	NavbarItems,
	NavbarItemsMobile,
} from "./constants/Dropdown.constants.tsx";
import {
	DashboardItemsEnum,
	NavbarItemsEnum,
} from "./interfaces/Dropdown.enum.ts";
interface DropdownDashboardProps {
	ref: React.RefObject<HTMLDivElement>;
}

const DropdownDashboard = forwardRef<HTMLDivElement, DropdownDashboardProps>(
	({}, ref) => {
		const dashboardMobileSections =
			NavbarItemsMobile[NavbarItemsEnum.DASHBOARDMOBILE].sections;

		const dashboardSections = NavbarItems[NavbarItemsEnum.DASHBOARD].sections;

		const dashboardItems =
			dashboardSections[DashboardItemsEnum.DASHBOARD].items;

		const indicadoresItems =
			dashboardSections[DashboardItemsEnum.INDICADORES].items;

		const dashboardMobileItems =
			dashboardMobileSections[DashboardItemsEnum.DASHBOARD].items;

		const memorizedDashboardItems = useMemo(() => {
			return dashboardItems.map((item) => (
				<div key={`dashboard-${item.rota}`} className="botao-menu-cte">
					<RotaItem key={`dashboard-${item.rota}`} item={item} />
				</div>
			));
		}, [dashboardItems]);

		const memorizedIndicadoresItems = useMemo(() => {
			return indicadoresItems.map((item) => (
				<div key={`indicadores-${item.rota}`} className="botao-menu-cte">
					<RotaItem key={`indicadores-${item.rota}`} item={item} />
				</div>
			));
		}, [indicadoresItems]);

		const memorizedDashboardMobileItems = useMemo(() => {
			return dashboardMobileItems.map((item) => (
				<div key={`dashboard-mobile-${item.rota}`} className="botao-menu-cte">
					<RotaItem key={`dashboard-mobile-${item.rota}`} item={item} />
				</div>
			));
		}, [dashboardMobileItems]);

		if (useIsMobile()) {
			return (
				<div className="section-list-mobile">
					<div className="separador-menu" />
					<div className="content-menu-rows-mobile">
						{memorizedDashboardMobileItems}
					</div>
				</div>
			);
		}

		return (
			<div className="dropdown-content-emb" ref={ref}>
				<div className="separador-menu-dashboard" />
				<div className="content-menu-rows">
					<DropdownSection
						titleSection={
							dashboardSections[DashboardItemsEnum.DASHBOARD].titleSection
						}
						icon={dashboardSections[DashboardItemsEnum.DASHBOARD].icon}
					>
						{memorizedDashboardItems}
					</DropdownSection>
					<DropdownSection
						titleSection={
							dashboardSections[DashboardItemsEnum.INDICADORES].titleSection
						}
						icon={dashboardSections[DashboardItemsEnum.INDICADORES].icon}
					>
						{memorizedIndicadoresItems}
					</DropdownSection>
				</div>
			</div>
		);
	},
);

export default DropdownDashboard;
